import { css } from 'styled-components';
import colors from '../../style/colors';
import { sizes as iconSizes } from '../icon/style';

export type InputSizesType = '2xxl' | 'xxl' | 'xl' | 'lg' | 'md' | 'auto';
type InputSizeProperties = {
  fontSize: string;
  height: string;
  iconSize: keyof typeof iconSizes;
  padding?: string;
  componentClass: 'textarea' | 'input';
};

const sizes: Record<InputSizesType, InputSizeProperties> = {
  '2xxl': {
    fontSize: '0.875rem',
    height: '164px',
    iconSize: 'xxl',
    componentClass: 'textarea',
  },
  xxl: {
    fontSize: '0.875rem',
    height: '118px',
    iconSize: 'xxl',
    componentClass: 'textarea',
  },
  xl: {
    fontSize: '0.875rem',
    height: '54px',
    iconSize: 'xl',
    componentClass: 'input',
  },
  lg: {
    fontSize: '0.875rem',
    height: '40px',
    iconSize: 'lg',
    componentClass: 'input',
  },
  md: {
    fontSize: '0.875rem',
    height: '32px',
    iconSize: 'sm',
    componentClass: 'input',
  },
  auto: {
    fontSize: '0.875rem',
    height: 'auto',
    iconSize: 'lg',
    componentClass: 'input',
  },
};

const types = {
  textarea: {},
  input: {},
};

const variants = {
  action: css`
    background: ${colors.white};

    &:focus,
    &.active,
    &.focus {
      border: 1px solid ${props => props.theme.actionColor};
    }
  `,

  clean: css`
    &,
    &:focus,
    &.focus {
      border: none;
      box-shadow: none;
    }

    &.disabled,
    &[disabled] {
      background: ${colors.white};
      color: ${colors.gray600};
      cursor: not-allowed;
    }
  `,

  'bottom-shadow': css`
    background: ${colors.white};
    box-shadow: 1px 4px 10px 0 rgba(0, 0, 0, 0.07);

    &:focus,
    &.active,
    &.focus {
      border: 1px solid ${props => props.theme.actionColor};
    }
  `,
};

export const inputBorderRadiusOptions = {
  sm: '2px',
  md: '16px',
  pill: '9999px',
};

export const defaultBorderRadiusByComponentClass: Record<
  InputSizeProperties['componentClass'],
  keyof typeof inputBorderRadiusOptions
> = {
  input: 'sm',
  textarea: 'sm',
};

export { sizes, types, variants };
